import { ActionReducer, MetaReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { DeleteStore } from './auth/actions/auth.actions';

export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    if (action.type === DeleteStore.type) {
      const endpoint = state.auth.endpoint;
      state = {};
      window.location.href = endpoint;
    }
    return reducer(state, action);
  };
}

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: [
      { auth: ['token', 'endpoint', 'user', 'lang', 'openSignin'] },
      'dashboard',
      'cancellation',
      'searchResult',
      'specialRequest',
      'involuntaryChanges',
      'settings',
      {
        voluntaryChanges: [
          'finalRequest',
          'voluntaryExchangeQuote',
          'splitRequired',
          'availabilities',
          'availabilitiesForm',
          'finalRequestState',
          'finalRequestError',
          'steps',
          'activeStep',
          'cabinTypes',
          'fareFamiliesState'
        ]
      }
    ],
    rehydrate: true
  })(reducer);
}

export const metaReducers: MetaReducer<any>[] = [debug, localStorageSyncReducer];
